<!------------------------------------------------>
<!--            환불금액 계산 컴포넌트            -->
<!------------------------------------------------>
<template>
  <div v-if="done" class="refund-card">
    <div class="refund-card__inner">
      <div class="refund-card__header">
        <span class="refund-card__title">환불 정보</span>
      </div>

      <div class="refund-card__section">
        <div class="refund-card__label" v-if="isPromotion">적용된 프로모션 요금제</div>
        <div class="refund-card__label" v-else>적용된 요금제</div>
        <div class="refund-card__value refund-card__value--primary">
          <template v-if="isPromotion">
            {{ `${cancelInfo.feeName} (년 ${formatToKoreanWon(cancelInfo.amountPerMonth)}원)` }}
          </template>
          <template v-else>
            {{ `${cancelInfo.feeName} (월 ${formatToKoreanWon(cancelInfo.feeOriginAmount)}원)` }}
          </template>
        </div>
      </div>

      <div v-if="cancelInfo.discountMethod" class="refund-card__section refund-card__section--discount">
        <div class="refund-card__label">적용된 할인</div>
        <div class="refund-card__value" v-if="cancelInfo.discountMethod === '00001'">
          {{ `${cancelInfo.discountName} (월 요금 ${formatToKoreanWon(cancelInfo.discountAmount)}원 할인)` }}
        </div>
        <div class="refund-card__value" v-if="cancelInfo.discountMethod === '00002'">
          {{ `${cancelInfo.discountName} (월 요금 ${cancelInfo.discountPercent}% 할인)` }}
        </div>
      </div>

      <div v-if="isFullRefund == false" class="refund-card__section">
        <div class="refund-card__label">남은 기간</div>
        <div v-if="cancelInfo.remainMonth < 1 && cancelInfo.remainDay < 1" class="refund-card__value">
          {{ '사용기간 종료' }}
        </div>
        <div v-else class="refund-card__value">
          {{ (cancelInfo.remainMonth > 0 ? cancelInfo.remainMonth + '개월 ' : '') + (cancelInfo.remainDay > 0 ? cancelInfo.remainDay + '일' : '') }}
        </div>
      </div>

      <!-- 프로모션 요금제 -->
      <template v-if="isPromotion">
        <div class="refund-card__section refund-card__section--breakdown">
          <div class="refund-card__label">요금 합계</div>
          <div class="refund-card__detail">
            <div class="refund-card__row">
              <span class="refund-card__row-label">기존 요금</span>
              <span class="refund-card__row-op">=</span>
              <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.amountPerMonth)}원` }}</span>
            </div>
            <div class="refund-card__row">
              <span class="refund-card__row-label">VAT(10%)</span>
              <span class="refund-card__row-op">=</span>
              <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.amountPerMonth * 0.1)}원` }}</span>
            </div>
          </div>
        </div>
        <div class="refund-card__section refund-card__section--total">
          <div class="refund-card__label">최종 환불 금액(VAT 10% 포함)</div>
          <v-text-field class="refund-card__total-input editor_bg rounded right-input" readonly solo suffix="원" :value="formatToKoreanWon(0)" />
        </div>
      </template>

      <!-- 공사기간 지났을 때 -->
      <template v-else-if="propsData.constructDtE.replaceAll('-', '') <= requestDt">
        <div class="refund-card__section refund-card__section--breakdown">
          <div class="refund-card__label">요금 합계</div>
          <div v-if="remark != ''" class="refund-card__remark">
            <span class="refund-card__remark-label">비고:</span>
            <span class="refund-card__remark-text">사용기간 종료, 환불 불가</span>
          </div>
        </div>
        <div class="refund-card__section refund-card__section--total">
          <div class="refund-card__label">최종 환불 금액(VAT 10% 포함)</div>
          <v-text-field
            class="refund-card__total-input editor_bg rounded right-input"
            readonly
            solo
            suffix="원"
            :value="formatToKoreanWon(cancelInfo.refundAmount)"
          />
        </div>
      </template>

      <!-- 일반 환불 계산 -->
      <template v-else>
        <div class="refund-card__section refund-card__section--breakdown">
          <div class="refund-card__label">요금 합계</div>
          <div class="refund-card__detail">
            <div class="refund-card__row">
              <span class="refund-card__row-label">기존 월 단위 요금</span>
              <span class="refund-card__row-op">=</span>
              <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.amountPerMonth)}원` }}</span>
            </div>
            <div v-if="cancelInfo.remainDay > 0" class="refund-card__row">
              <span class="refund-card__row-label">일 단위 요금</span>
              <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.amountPerMonth)}원 / 30일` }}</span>
              <span class="refund-card__row-op">=</span>
              <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.amountPerDay)}원` }}</span>
            </div>
            <div v-if="remark != ''" class="refund-card__remark">
              <span class="refund-card__remark-label">비고:</span>
              <span class="refund-card__remark-text">{{ remark }}</span>
            </div>
            <template v-if="remark == ''">
              <div v-if="cancelInfo.remainMonth > 0" class="refund-card__row refund-card__row--sub">
                <span class="refund-card__row-label">환불 받을 금액 (월 단위)</span>
                <span class="refund-card__row-value">{{
                  `${formatToKoreanWon(cancelInfo.amountPerMonth)}원 × 남은 기간(${cancelInfo.remainMonth}개월)`
                }}</span>
                <span class="refund-card__row-op">=</span>
                <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.refundAmountMonth)}원` }}</span>
              </div>
              <div v-if="cancelInfo.remainDay > 0" class="refund-card__row">
                <span class="refund-card__row-label">환불 받을 금액 (일 단위)</span>
                <span class="refund-card__row-value">{{
                  `${formatToKoreanWon(cancelInfo.amountPerDay)}원 × 남은 기간(${cancelInfo.remainDay}일)`
                }}</span>
                <span class="refund-card__row-op">=</span>
                <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.refundAmountDay)}원` }}</span>
              </div>
              <div class="refund-card__row">
                <span class="refund-card__row-label">합계 환불 금액 (1자리 올림)</span>
                <span class="refund-card__row-op">=</span>
                <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.refundSubtotalAmount)}원` }}</span>
              </div>
              <div class="refund-card__row">
                <span class="refund-card__row-label">환불 VAT (10%)</span>
                <span class="refund-card__row-op">=</span>
                <span class="refund-card__row-value">{{ `${formatToKoreanWon(cancelInfo.vat)}원` }}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="refund-card__section refund-card__section--total">
          <div class="refund-card__label">최종 환불 금액(VAT 10% 포함)</div>
          <v-text-field
            class="refund-card__total-input editor_bg rounded right-input"
            readonly
            solo
            suffix="원"
            :value="formatToKoreanWon(cancelInfo.refundAmount)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// 컴포넌트
import baseview from '@/views/base/baseview.vue'
// api
import { getCustomerLoginHistoryAferPayment, requestCancel } from '@/payment/api/toss'

import { getCancelInfo } from '@/api/adminManagement/cancelManage'

import { getCurrentDate } from '@/utils/common.js'
//
export default {
  mixins: [baseview],
  components: {},
  name: 'calcCancelAmount',
  props: {
    orderId: {
      type: String,
      default: () => '', // 랜더링 키값
    },
    isPromotion: {
      type: Boolean,
      default: () => false, // 프로모션 요금제 여부
    },
    propsData: {
      type: Object,
      default: () => {}, // 프로모션 요금제 여부
    },
  },
  data() {
    return {
      cancelInfo: {},
      done: false,
      remark: '',
      requestDt: getCurrentDate().replaceAll('-', ''),
      isFullRefund: false,
      customerLoginDate: null,
    }
  },
  watch: {
    orderId: {
      deep: true,
      handler() {
        this.btnSearch()
      },
    },
  },
  activated() {},
  created() {
    this.btnSearch()
  },
  mounted() {
    this.btnSearch()
  },
  methods: {
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      }
      return 0
    },
    btnSearch() {
      if (!this.orderId) return
      this.done = false
      this.cancelInfo = {}
      this.remark = ''
      this.isFullRefund = false
      this.customerLoginDate = null
      console.log('#### 환불 정보 ', this.propsData)

      const param = {
        clntId: this.propsData.clntId,
        compId: this.propsData.compId,
        writeDt: this.propsData.writeDt,
        docNo: this.propsData.docNo,
        orderId: this.orderId,
      }
      getCancelInfo(param, true).then((res) => {
        this.cancelInfo = res
        this.requestDt = res.cancelRequestDt || getCurrentDate().replaceAll('-', '')

        const customerParam = {
          clntId: this.propsData.clntId,
          orderId: this.orderId,
        }
        // 로그인 여부 조회
        getCustomerLoginHistoryAferPayment(customerParam)
          .then((res) => {
            if (res.loginDate) {
              this.customerLoginDate = res.loginDate
            }
          })
          .finally(() => {
            console.log('### this.cancelInfo', this.cancelInfo)
            console.log('### this.this.customerLoginDate', this.customerLoginDate)
            if (this.cancelInfo.paymentStatus == 'N') {
              this.cancelInfo.refundAmount = this.cancelInfo.paymentAmount
              this.remark = '결제 승인 전, 전액 환불'
              this.isFullRefund = true
            } else if (!this.customerLoginDate && this.cancelInfo.useMonth == 0) {
              console.log('### this.this.customerLoginDate')
              if (this.cancelInfo.useDay <= 7) {
                //미사용 7일 이내
                this.cancelInfo.refundAmount = this.cancelInfo.paymentAmount
                this.remark = '미사용 7일 이내, 컨설팅 비용 제외 전액 환불'
                this.isFullRefund = true
              } else {
                // 월 요금의 1/3만 차감하여 계산
                this.cancelInfo.refundAmount = Math.ceil(this.cancelInfo.paymentAmount - this.cancelInfo.amountPerMonth / 3)
                this.remark = '미사용 1개월 이내, 월요금의 1/3만 차감'
                this.isFullRefund = false
              }
            } else if (this.cancelInfo.remainMonth === 0 && this.cancelInfo.remainDay < 7) {
              this.cancelInfo.refundAmount = 0
              this.remark = '남은 사용 기간 7일 미만, 환불 불가'
              this.isFullRefund = false
            }
            if (this.propsData.constructDtE.replaceAll('-', '') <= this.requestDt) {
              this.cancelInfo.refundAmount = 0
            }
            this.calculateRefundAmount()
            this.done = true
            this.$emit('done', true)
          })
      })
    },
    getAmount() {
      // VAT 포함 금액 호출 시 true
      console.log('##### this.cancelInfo.refundAmount', this.cancelInfo.refundAmount)
      return this.cancelInfo.refundAmount
    },
    calculateRefundAmount() {
      const info = this.cancelInfo

      const paymentAmount = Number(info.paymentAmount) || 0
      const amountPerMonth = Number(info.amountPerMonth) || 0
      const refundAmountMonth = Number(info.refundAmountMonth) || 0
      const refundAmountDay = Number(info.refundAmountDay) || 0

      info.refundSubtotalAmount = 0
      info.vat = 0
      info.refundAmount = 0

      const constructDtE = (this.propsData.constructDtE || '').replaceAll('-', '')
      const isExpired = constructDtE && constructDtE <= this.requestDt

      // 프로모션 요금제
      if (this.isPromotion) {
        info.refundAmount = 0
        return
      }

      // 사용기간 종료
      if (isExpired) {
        this.remark = '사용기간 종료, 환불 불가'
        info.refundAmount = 0
        return
      }

      // 결제 승인 전
      if (info.paymentStatus === 'N') {
        info.refundAmount = paymentAmount
        this.remark = '결제 승인 전, 전액 환불'
        this.isFullRefund = true
        return
      }

      // 로그인 이력이 없고 사용기간이 1개월 미만
      if (!this.customerLoginDate && info.useMonth === 0) {
        if (info.useDay <= 7) {
          info.refundAmount = paymentAmount
          this.remark = '미사용 7일 이내, 컨설팅 비용 제외 전액 환불'
          this.isFullRefund = true
        } else {
          info.refundAmount = Math.ceil(
            paymentAmount - amountPerMonth / 3
          )
          console.log("=======")
          console.log(paymentAmount)
          console.log(amountPerMonth)
          this.remark = '미사용 1개월 이내, 월요금의 1/3만 차감'
          this.isFullRefund = false
        }

        return
      }

      // 남은 기간이 7일 미만
      if (info.remainMonth === 0 && info.remainDay < 7) {
        info.refundAmount = 0
        this.remark = '남은 사용 기간 7일 미만, 환불 불가'
        this.isFullRefund = false
        return
      }

      // 일반 환불 계산
      info.refundSubtotalAmount =
        Math.ceil((refundAmountMonth + refundAmountDay) / 10) * 10

      info.vat = info.refundSubtotalAmount * 0.1
      info.refundAmount =
        info.refundSubtotalAmount + info.vat
    }
  },
}
</script>
<style scoped>
.refund-card {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.refund-card__inner {
  padding: 0;
}

.refund-card__header {
  padding: 14px 20px;
  background: linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%);
  color: #fff;
}

.refund-card__title {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.refund-card__section {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.refund-card__section:last-child {
  border-bottom: none;
}

.refund-card__section--total {
  background: #faf5ff;
  padding: 18px 20px;
}

.refund-card__section--discount {
  background: #fefdf8;
}

.refund-card__section--breakdown {
  background: #fafbfc;
}

.refund-card__label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.refund-card__value {
  font-size: 0.9375rem;
  color: #1e293b;
  line-height: 1.5;
}

.refund-card__value--primary {
  font-weight: 600;
  color: #0f172a;
}

.refund-card__detail {
  margin-top: 4px;
}

.refund-card__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 6px 0;
  font-size: 0.875rem;
  color: #334155;
  line-height: 1.5;
  gap: 4px 8px;
}

.refund-card__row--sub {
  padding-top: 10px;
  margin-top: 4px;
  border-top: 1px dashed #e2e8f0;
}

.refund-card__row-label {
  color: #64748b;
}

.refund-card__row-value {
  color: #1e293b;
  font-weight: 500;
}

.refund-card__row-op {
  margin: 0 4px;
  color: #94a3b8;
  font-weight: 500;
}

.refund-card__remark {
  margin-top: 10px;
  padding: 10px 12px;
  background: #fef3c7;
  border-radius: 8px;
  border-left: 3px solid #f59e0b;
  font-size: 0.875rem;
}

.refund-card__remark-label {
  font-weight: 600;
  color: #92400e;
  margin-right: 6px;
}

.refund-card__remark-text {
  color: #78350f;
}

.refund-card__total-input >>> .v-input__slot {
  background: #fff !important;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.refund-card__total-input >>> input {
  text-align: right;
  font-size: 1.125rem !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

.right-input >>> input {
  text-align: right;
}
</style>
